import { RateQuote } from '../../rate';
import { ProposedShipment } from '../ProposedShipment';

// This type is 3 concatenated types, which is easier to read with a separate
// line for each constituent type, but prettier wants to lay it out in a
// ridiculous way
// prettier-ignore
type ConstructableProposedShipmentCreationError =
  Required<Pick<ProposedShipmentCreationError, 'proposedShipment'>> &
  Partial<Pick<ProposedShipmentCreationError, 'rateQuote'>> &
  { cause: Error };

export class ProposedShipmentCreationError extends window.Error {
  proposedShipment: ProposedShipment;
  rateQuote?: RateQuote;

  constructor(opts: ConstructableProposedShipmentCreationError) {
    super(
      `Error creating proposed shipment ${opts.proposedShipment.identifier}`,
      { cause: opts.cause },
    );

    this.name = ProposedShipmentCreationError.name;
    this.proposedShipment = new ProposedShipment(opts.proposedShipment);
    this.rateQuote = new RateQuote(opts.rateQuote);
  }
}
